import { LegalLayout } from '@/components/LegalLayout';
import { useLanguage } from '@/lib/i18n/LanguageContext';

export default function CookiePage() {
  const { lang } = useLanguage();

  if (lang === 'tr') return (
    <LegalLayout title="Çerez Politikası" lastUpdated="24 Şubat 2026">
      <p>Safe Crypto (safecrypto.ai) olarak, platformumuzda çerezler ve benzeri teknolojiler kullanmaktayız. Bu politika, hangi çerezleri neden kullandığımızı ve tercihlerinizi nasıl yönetebileceğinizi açıklar.</p>

      <h2>1. Çerez Nedir?</h2>
      <p>Çerezler, web sitemizi ziyaret ettiğinizde cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler, siteyi tekrar ziyaret ettiğinizde sizi tanımamıza ve deneyiminizi kişiselleştirmemize yardımcı olur.</p>

      <h2>2. Kullandığımız Çerez Türleri</h2>
      <h3>a) Zorunlu Çerezler</h3>
      <p>Platformun temel işlevleri için gereklidir. Oturum yönetimi, güvenlik doğrulaması ve yük dengeleme gibi işlevleri sağlar. Bu çerezler devre dışı bırakılamaz.</p>
      <h3>b) Performans Çerezleri</h3>
      <p>Platformun nasıl kullanıldığına dair anonim istatistiksel veriler toplar. Sayfa yükleme süreleri, hata oranları ve kullanıcı etkileşimleri analiz edilir.</p>
      <h3>c) İşlevsellik Çerezleri</h3>
      <p>Dil tercihi, tema seçimi (karanlık/aydınlık mod), para birimi tercihi gibi kişisel ayarlarınızı hatırlar.</p>
      <h3>d) Güvenlik Çerezleri</h3>
      <p>İki faktörlü kimlik doğrulama (2FA), oturum tokenleri ve CSRF koruması için kullanılır.</p>

      <h2>3. Üçüncü Taraf Çerezleri</h2>
      <ul>
        <li><strong>WalletConnect:</strong> Kripto cüzdan bağlantısı için</li>
        <li><strong>CoinGecko:</strong> Piyasa verileri için</li>
      </ul>

      <h2>4. Çerez Saklama Süreleri</h2>
      <ul>
        <li>Oturum çerezleri: Tarayıcı kapatıldığında silinir</li>
        <li>Kalıcı çerezler: 30 gün - 1 yıl arası</li>
        <li>Güvenlik çerezleri: Oturum süresince</li>
      </ul>

      <h2>5. Çerez Tercihlerinizi Yönetme</h2>
      <p>Tarayıcı ayarlarınızdan çerezleri kontrol edebilir veya silebilirsiniz. Ancak zorunlu çerezlerin devre dışı bırakılması platformun düzgün çalışmasını engelleyebilir.</p>

      <h2>6. İletişim</h2>
      <p>Çerez politikamız hakkında sorularınız için <strong>support@safecrypto.ai</strong> adresinden bize ulaşabilirsiniz.</p>
    </LegalLayout>
  );

  return (
    <LegalLayout title="Cookie Policy" lastUpdated="February 24, 2026">
      <p>As Safe Crypto (safecrypto.ai), we use cookies and similar technologies on our platform. This policy explains which cookies we use, why, and how you can manage your preferences.</p>

      <h2>1. What Are Cookies?</h2>
      <p>Cookies are small text files stored on your device when you visit our website. They help us recognize you on return visits and personalize your experience.</p>

      <h2>2. Types of Cookies We Use</h2>
      <h3>a) Essential Cookies</h3>
      <p>Required for core platform functionality including session management, security verification, and load balancing. These cannot be disabled.</p>
      <h3>b) Performance Cookies</h3>
      <p>Collect anonymous statistical data about platform usage including page load times and error rates.</p>
      <h3>c) Functionality Cookies</h3>
      <p>Remember your personal settings such as language preference, theme selection, and currency preference.</p>
      <h3>d) Security Cookies</h3>
      <p>Used for two-factor authentication (2FA), session tokens, and CSRF protection.</p>

      <h2>3. Third-Party Cookies</h2>
      <ul>
        <li><strong>WalletConnect:</strong> For crypto wallet connections</li>
        <li><strong>CoinGecko:</strong> For market data</li>
      </ul>

      <h2>4. Cookie Retention Periods</h2>
      <ul>
        <li>Session cookies: Deleted when browser is closed</li>
        <li>Persistent cookies: 30 days - 1 year</li>
        <li>Security cookies: Duration of session</li>
      </ul>

      <h2>5. Managing Your Cookie Preferences</h2>
      <p>You can control or delete cookies through your browser settings. However, disabling essential cookies may prevent the platform from functioning properly.</p>

      <h2>6. Contact</h2>
      <p>For questions about our cookie policy, contact us at <strong>support@safecrypto.ai</strong>.</p>
    </LegalLayout>
  );
}
